export function checkIsImage(file: File | string) {
  if (typeof file === 'string')
    return /(\.png|\.jpeg|\.jpg|\.gif|\.bmp|\.tiff|\.svg)$/.test(
      file.toLowerCase()
    )

  return /^image\//.test(file.type)
}
